import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { pick } from "lodash-es";
import { default as _ignoreConsole } from "ignore-console";
import { sendMessage } from "../store/useMicroAppStore";
import { generatePath, matchRoutes } from "react-router-dom";
export var ignoreConsole = _ignoreConsole;
export var getChildPathname = function getChildPathname(pathname, baseRoute) {
  var pathReg = new RegExp("^".concat(baseRoute));
  return pathname.replace(pathReg, "");
};
export var getDisplayHiddenStyle = function getDisplayHiddenStyle(compare) {
  var displayHiddenStyle = {
    display: "none"
  };
  if (typeof compare === "function") {
    return compare() ? displayHiddenStyle : {};
  } else {
    return compare ? displayHiddenStyle : {};
  }
};
export var noticeSubAppRemovePanes = function noticeSubAppRemovePanes(panes, routesPaths) {
  // 通知子应用关闭
  var removedAppData = panes.reduce(function (pre, cur) {
    if (cur.microApp) {
      var purePath = getChildPathname(cur.microAppPath || cur.path, cur.microApp.baseRoute);
      var _ref = matchRoutes(routesPaths, cur.path) || [],
        _ref2 = _slicedToArray(_ref, 1),
        microMatchRoute = _ref2[0];
      var childPathnameWithParams = generatePath(purePath, microMatchRoute.params || {});
      if (pre[cur.microApp.name]) {
        pre[cur.microApp.name].push(childPathnameWithParams);
      } else {
        pre[cur.microApp.name] = [childPathnameWithParams];
      }
    }
    return pre;
  }, {});
  console.log("%c Line:56 🍤 removedAppData", "color:#3f7cff", removedAppData);
  Object.keys(removedAppData).forEach(function (appName) {
    sendMessage(appName, {
      event: "tabRemoved",
      data: {
        pathnames: removedAppData[appName]
      }
    }, {
      sync: true
    });
  });
};

/**
 * 生成扁平路由数组
 */
export var getFlatRoutes = function getFlatRoutes(route) {
  var flatPathObject = {};
  function getFlat(list, parent) {
    list.forEach(function (el) {
      var _el$children, _el$children2;
      var newRoute = pick(el, ["key", "path", "id", "name", "parentId", "keepAlive", "microAppPath", "hideInBreadcrumb", "menuGroup", "hideInMenu", "redirect"]);
      // 是否有子菜单
      newRoute.hasChild = ((_el$children = el.children) === null || _el$children === void 0 ? void 0 : _el$children.length) || 0;
      var hideInMenuChildren = ((_el$children2 = el.children) === null || _el$children2 === void 0 || (_el$children2 = _el$children2.filter(function (item) {
        if (item.path === "") {
          return true;
        }
        return item.hideInMenu === true;
      })) === null || _el$children2 === void 0 ? void 0 : _el$children2.length) || 0;
      // 是否都为隐式子菜单,为true则都为hideInMenu菜单
      newRoute.isAllImplicit = hideInMenuChildren === newRoute.hasChild;
      if (parent) {
        el.parentPath = newRoute.parentPath = (parent === null || parent === void 0 ? void 0 : parent.path) || "";
      }
      if (el.path) {
        flatPathObject[el.path] = newRoute;
      }

      // 子路由path为空，则替换父路由path
      // if(el.path === ""){
      //   newRoute.path = parent.path
      //   flatPathObject[parent.path] = newRoute;
      // }

      var elArray = el.children;
      if (elArray !== null && elArray !== void 0 && elArray.length) {
        getFlat(elArray, el);
      }
    });
  }
  getFlat(route, null);
  return flatPathObject;
};

/**
 * 格式化routes，去除边缘情况
 * @param routes
 */
export var formatRoutes = function formatRoutes(routes) {
  var result = _toConsumableArray(routes);
  function format(list, parent) {
    list.forEach(function (el) {
      if (el.path === "" && parent !== null && parent !== void 0 && parent.path) {
        el.path = parent.path;
        parent.path = "";
      }
      var elArray = el.children;
      if (elArray !== null && elArray !== void 0 && elArray.length) {
        format(elArray, el);
      }
    });
  }
  format(result, null);
  return result;
};